module.exports = __webpack_public_path__ + "static/media/imagen logo.cf536224.jpg";